import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "react-bootstrap";
import "./section-header.style.scss";

export interface SectionHeaderProps {
  titleKey: string;
  subtitleKey?: string;
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  containerClassName?: string;
  alignment?: "left" | "center" | "right";
  showContainer?: boolean;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  titleKey,
  subtitleKey,
  className = "section-header",
  titleClassName = "section-title",
  subtitleClassName = "section-subtitle",
  containerClassName = "section-header-container",
  alignment = "center",
  showContainer = true,
}) => {
  const { t } = useTranslation();

  const alignmentClass = alignment === "left" ? "text-start" :
    alignment === "right" ? "text-end" : "text-center";

  const content = (
    <div className={`${alignmentClass}`}>
      <h1 className={titleClassName}>{t(titleKey)}</h1>
      {subtitleKey && <div className={subtitleClassName}>{t(subtitleKey)}</div>}
    </div>
  );

  if (!showContainer) {
    return (
      <div className={className}>
        {content}
      </div>
    );
  }

  return (
    <div className={className}>
      <Container className={`h-100 d-flex align-items-center justify-content-center ${containerClassName}`}>
        <Row className="w-100 justify-content-between align-items-center px-0">
          <Col className={alignmentClass}>
            {content}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SectionHeader;
